import { toast } from 'react-toastify'
import { error, success } from './constants'

export const toastMessage = (message, type) => {
  //console.log('message : ', message)
  //console.log('type : ', type)
  toast(message, {
    hideProgressBar: false,
    // type: type,
    position: 'top-center',
    pauseOnHover: true,
    className: 'toast-message'
  })
}
export const bulkUploadPopup = (data, addData) => {
  if (data.data.length > 0 && data.failedData.length > 0) {
    toastMessage(`${data.data.length} Data Inserted Successfully`, success)
    toastMessage(`${data.failedData.length} Data Failed To Upload`, error)
  } else {
    if (data.data.length > 0) {
      data.data.map((item) => addData(item))
      return toastMessage(`${data.data.length} Data Inserted Successfully`, success)
    } else {
      if (data.failedData.length > 0) {
        return toastMessage(`${data.failedData.length} Data Failed To Upload`, error)
      }
    }
  }
}
